import {ADataGridFilter} from "@atiautomacao/ati-ui-library";

const LOWERCASE_SAFE_CONDITIONS: ReadonlyArray<ADataGridFilter["condition"]> = [
    "contains",
    "starts-with",
    "ends-with",
];

export const isLowercaseSafeCondition = (condition: ADataGridFilter["condition"]): boolean =>
    LOWERCASE_SAFE_CONDITIONS.includes(condition);

export const toLowerCaseFilterValues = (filters: Array<ADataGridFilter>): Array<ADataGridFilter> =>
    filters.map((filter) =>
        isLowercaseSafeCondition(filter.condition) && filter.value
            ? {...filter, value: filter.value.toLowerCase()}
            : {...filter}
    );
